import { action, computed } from 'mobx';
import { ToasterOptions } from '../models/configuration/FeedbackConfig';
import { FeedbackStore } from '.';
import { FeedbackType } from '../Components/Feedback/Components/Toast/Models';
import { ToastFeedbackMessage } from '../Components/Feedback/Models';
import { Stores } from '../models/Stores';

export class ToastStore {
    key: string;
    text: string;
    options: ToasterOptions;
    type: FeedbackType;
    feedbackStore: FeedbackStore;

    constructor(
        stores: Stores,
        key: string,
        feedbackMessage: ToastFeedbackMessage
    ) {
        const { config, text, feedbackType } = feedbackMessage;
        this.options = config?.toasterOptions;
        this.text = text;

        this.key = key;
        this.feedbackStore = stores.feedback;
        this.type = feedbackType;

        const autoClose =
            this.options?.autoClose !== undefined
                ? this.options.autoClose
                : true;
        const displaySeconds = this.options?.displaySeconds || 3;
        if (autoClose) {
            setTimeout(() => {
                this.removeToast();
            }, displaySeconds * 1000);
        }
    }

    @action
    removeToast = () => {
        this.feedbackStore.removeToast(this.key);
    };

    @computed
    get closeIcon(): string {
        return this.options?.iconOptions?.closeIconFilename || 'CloseIcon';
    }

    @computed
    get showClose(): boolean {
        return this.options?.showClose || false;
    }
}



// WEBPACK FOOTER //
// ./src/stores/ToastStore.ts